import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getMeassageList, getMessageInfo, getUnreadMeassageCountInfo, setAllDoneRead, } from './service';
import { Spin, Pagination, message, Modal, Button, Card, Input, Radio, Tabs, } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './index.less';
import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import classnames from 'classnames';
import { getAdminApplyApi, getBoxInfoApi } from './service';
import ReceiverDraw from './components/enterprice/ReceiverDraw';
import SenderDraw from './components/enterprice/SenderDraw';
import FinanceAdminDraw from './components/enterprice/FinanceAdminDraw';
import CertifySenderDraw from './components/enterprice/CertifySenderDraw';
import { useSearchParams } from 'react-router-dom';
import { Empty, freeTablePagination } from '@core/rc-components';
import { MESSAGE_IMG_MAP } from './constants';
import { useJumpPageRouteGet, useSharedGlobalState } from '@/shared/hooks';
import { MessageDetail } from './components/MessageDetail';
const PATH_PRE_ENUM = {
    UIMS_1013: 'uims1013',
    UIMS_1014: 'uims1014',
    UIMS_1015: 'uims1015',
    UIMS_1018: 'uims1018',
    UIMS_1019: 'uims1019',
    UIMS_1021: 'uims1021',
    UIMS_1022: 'uims1022', // 财务管理员审核附件
};
const systemAuthors = {
    QUERY: 'TABLE-QUERY',
    GET: 'TABLE-GET',
    readAll: 'TABLE-PROCESS',
    GROUP: 'TABLE-RPT_GROUP',
    CONFIRM: 'TABLE-CONFIRM', //已读/批量已读
};
const headers = {
    'function-code': systemAuthors.QUERY,
};
const getInBoxEnums = (userInfo) => {
    const pt = sessionStorage.getItem('pt');
    // 站内信订阅
    let inboxSubUrl = `/wstopic/inbox/${pt}/${userInfo.id}`;
    if (userInfo.defaultCompId && userInfo.defaultCompId !== '0') {
        inboxSubUrl += `/${userInfo.defaultCompId}`;
    }
    // 站内信订阅 全局订阅
    return [inboxSubUrl, `/wstopic/inbox/${pt}/${userInfo.id}/0`];
};
const searchParamsColumns = {
    searchTypeId: 'typeId',
};
const MessageIndex = ({ msgTypeId, tabItems }) => {
    // typeId 消息类型
    const [searchParams] = useSearchParams();
    const globalProps = useSharedGlobalState();
    const [selectedTabKey, setSelectedTabKey] = useState(msgTypeId ?? -1);
    const [tabList, setTabList] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [inputKeyword, setInputKeyword] = useState('');
    // 是否已读状态
    const [isRead, setIsRead] = useState('');
    const [open, setOpen] = useState(false);
    // 搜索字段
    const [keyword, setKeyword] = useState('');
    const [dataList, setDataList] = useState({
        total: 0,
        data: [],
    });
    const [page, setPage] = useState({
        pageNum: 1,
        pageSize: 10,
    });
    const [drawVisibleObj, setDrawVisibleObj] = useState({
        financeAdminDraw: false,
        senderDraw: false,
        receiverDraw: false,
        certifySenderDraw: false,
        id: '',
        rowInfo: { id: '' },
        nameList: [],
    });
    // 跳转路由
    const { getJumpPagePath } = useJumpPageRouteGet();
    const momentDate = (date) => {
        if (date && date !== 0) {
            return moment(date).format('YYYY-MM-DD HH:mm');
        }
        else {
            return date;
        }
    };
    const getTabList = (cb) => {
        getUnreadMeassageCountInfo().then((res) => {
            if (res.code === 200 && res.data && res.data.MsgRecordsTotal) {
                if (!isEmpty(tabItems)) {
                    //有传递tabs，就只展示tabs
                    const newTabs = tabItems?.map?.(item => {
                        const reqItem = res.data.MsgRecordsTotal?.find?.(reqItem => reqItem.msgTypeId == item.msgTypeId);
                        return {
                            ...item,
                            number: Number(reqItem?.number || 0)
                        };
                    });
                    console.log("🚀 ~ getUnreadMeassageCountInfo ~ newTabs:", newTabs);
                    setTabList(newTabs);
                    cb?.(newTabs);
                }
                else {
                    let total = 0;
                    const newTabs = res.data.MsgRecordsTotal ?? [];
                    newTabs.forEach((item) => {
                        total += Number(item.number);
                    });
                    newTabs.unshift({
                        msgTypeName: '全部',
                        msgTypeId: '',
                        number: total,
                    });
                    const typeId = searchParams.get(searchParamsColumns.searchTypeId);
                    if (typeId && selectedTabKey === -1) {
                        const typeIndex = newTabs.findIndex((item) => item.msgTypeId === typeId);
                        setSelectedTabKey(typeIndex === -1 ? 0 : typeIndex);
                    }
                    setTabList(newTabs);
                    cb?.(newTabs);
                }
            }
        });
    };
    const getDataList = () => {
        let userInfo = sessionStorage.getItem('USER_INFO');
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
        }
        setDataLoading(true);
        const msgTypeId = selectedTabKey === -1
            ? searchParams.get(searchParamsColumns.searchTypeId)
            : tabList[selectedTabKey]?.msgTypeId;
        getMeassageList({
            ...page,
            msgTypeId: msgTypeId ?? undefined,
            text: keyword,
            isRead: isRead,
            userId: userInfo?.id,
        })
            .then((res) => {
            const newDatas = {
                total: 0,
                data: [],
            };
            if (res.code === 200 && res.data.rows) {
                res.data.rows.forEach((item) => {
                    // 判断是否是富文本
                    if (/<[^>]+>/g.test(item.content)) {
                        item.isEditorContent = 1;
                    }
                });
                newDatas.data = res.data.rows;
                newDatas.total = res.data.total;
            }
            setDataList(newDatas);
            setDataLoading(false);
        })
            .catch(() => {
            setDataList({
                total: 0,
                data: [],
            });
            setDataLoading(false);
        });
    };
    // 已读
    const getDataInfo = (data, index, cb) => {
        setDataLoading(true);
        getMessageInfo(data.id)
            .then((res) => {
            setDataLoading(false);
            if (res.code === 200) {
                const newData = cloneDeep(dataList.data);
                newData[index].isRead = true;
                setDataList({
                    ...dataList,
                    data: newData,
                });
                // 全部减去已读的
                const newTabs = cloneDeep(tabList);
                newTabs[0].number = tabList[0].number - 1;
                if (selectedTabKey === 0) {
                    // 减去对应类型的数量
                    newTabs.forEach((item) => {
                        if (item.msgTypeId === data.msgTypeId) {
                            item.number = item.number - 1;
                        }
                    });
                }
                else {
                    const itemTemp = tabList[selectedTabKey];
                    newTabs[selectedTabKey].number = itemTemp.number - 1;
                }
                setTabList(newTabs);
                cb?.();
            }
        })
            .catch(() => setDataLoading(false));
    };
    const setAllMsgReaded = () => {
        Modal.confirm({
            title: `已读`,
            content: `点击已读后，将${selectedTabKey === 0 ? '' : tabList[selectedTabKey]?.msgTypeName}所有消息置为已读，是否继续`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                setAllDoneRead(selectedTabKey === 0 ? -1 : tabList[selectedTabKey]?.msgTypeId).then((res) => {
                    if (res.code === 200) {
                        message.success(`已成功将${selectedTabKey === 0 ? '' : tabList[selectedTabKey]?.msgTypeName}所有消息置为已读`);
                        const readNum = tabList[selectedTabKey]?.number;
                        const newTabs = cloneDeep(tabList);
                        // 全部减去已读的
                        if (selectedTabKey === 0) {
                            newTabs.forEach((item) => {
                                item.number = 0;
                            });
                        }
                        else {
                            newTabs[0].number = tabList[0].number - readNum;
                            newTabs[selectedTabKey].number = 0;
                        }
                        setTabList(newTabs);
                        // 动态更新tab数据，主要是更新全局未读数
                        getTabList();
                        // 将本页数据设为已读
                        const newData = cloneDeep(dataList.data);
                        newData.forEach((item) => {
                            item.isRead = true;
                        });
                        setDataList({
                            ...dataList,
                            data: newData,
                        });
                    }
                });
            },
        });
    };
    const onTabChange = (index) => {
        setSelectedTabKey(parseInt(index));
        setInputKeyword('');
        setKeyword('');
        setPage({
            ...page,
            pageNum: 1,
        });
    };
    const toPath = (data) => {
        // 更换管理员申请 - 详情抽屉
        if ([
            PATH_PRE_ENUM.UIMS_1013,
            PATH_PRE_ENUM.UIMS_1014,
            PATH_PRE_ENUM.UIMS_1015,
        ].includes(data.busCode)) {
            const { busCode, busId } = data;
            if (busCode === PATH_PRE_ENUM.UIMS_1014) {
                getAdminApplyApi(busId).then((res) => {
                    if (res.code === 200) {
                        let userInfo = sessionStorage.getItem('USER_INFO');
                        if (userInfo) {
                            userInfo = JSON.parse(userInfo);
                        }
                        if (res.data.employeeId === userInfo.employeeId) {
                            setDrawVisibleObj({
                                ...drawVisibleObj,
                                senderDraw: true,
                                rowInfo: res.data,
                                id: res.data?.id,
                            });
                        }
                        else {
                            setDrawVisibleObj({
                                ...drawVisibleObj,
                                receiverDraw: true,
                                id: res.data?.id,
                                rowInfo: res.data,
                            });
                        }
                    }
                });
            }
            else if (busCode === PATH_PRE_ENUM.UIMS_1013) {
                getBoxInfoApi(busId, headers).then((res) => {
                    if (res.code === 200) {
                        const { employeeInfo, financeCertification, records = [], } = res.data;
                        const nameString = employeeInfo
                            .map((v) => v.employeeName)
                            .join(',');
                        setDrawVisibleObj({
                            ...drawVisibleObj,
                            financeAdminDraw: true,
                            rowInfo: {
                                ...financeCertification,
                                ...records[0],
                            },
                            nameList: nameString.split(','),
                        });
                    }
                });
            }
            else if (busCode === PATH_PRE_ENUM.UIMS_1015) {
                setDrawVisibleObj({
                    ...drawVisibleObj,
                    certifySenderDraw: true,
                    id: busId,
                });
            }
        }
        else if (data.appType === 'SYSTEM_BUS_CODE') {
            getJumpPagePath({
                ...data,
                businessCode: data.busCode,
                businessKey: data.busId,
            }, {
                baseOnOrigin: 'message',
            }).then((directPath) => {
                if (directPath) {
                    window.location.href = directPath;
                }
            });
        }
        else if (data.webUrl) {
            // 修复不按规则输入的网址，
            let webUrl = data.webUrl;
            // 校验是否是有效的网址
            const reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
            if (reg.test(webUrl)) {
                if (webUrl.indexOf('//') === -1) {
                    webUrl = '//' + webUrl; // bu'z
                }
            }
            else if (webUrl.indexOf(window.location.origin) === -1 &&
                webUrl.indexOf('//') === -1) {
                webUrl = window.location.origin + webUrl;
            }
            window.open(webUrl, '_blank');
        }
    };
    const onMsgClick = (data, index) => {
        if (data.isColleps === 1) {
            const newData = cloneDeep(dataList.data);
            newData[index].isColleps = 2;
            setDataList({
                ...dataList,
                data: newData,
            });
        }
        // console.log({ data })
        if (!data.isRead) {
            getDataInfo(data, index, () => {
                toPath(data);
            });
        }
        else {
            toPath(data);
        }
    };
    const onMsgReadAll = (e, index, close) => {
        e.stopPropagation();
        const newData = cloneDeep(dataList.data);
        newData[index].isColleps = close === true ? 1 : 2;
        setDataList({
            ...dataList,
            data: newData,
        });
        if (close !== true) {
            if (!newData[index].isRead) {
                getDataInfo(newData[index], index, () => {
                    toPath(newData[index]);
                });
            }
            else {
                toPath(newData[index]);
            }
        }
    };
    useEffect(() => {
        const manualRequest = searchParams.get(searchParamsColumns.searchTypeId) &&
            selectedTabKey === -1;
        if (manualRequest) {
            setDataLoading(true);
        }
        else {
            getDataList();
        }
    }, [page, selectedTabKey]);
    useEffect(() => {
        if (!searchParams.get(searchParamsColumns.searchTypeId)) {
            setSelectedTabKey(0);
        }
        getTabList();
    }, []);
    // 本页消息订阅
    useEffect(() => {
        const userInfo = globalProps?.userInfoFromSession;
        const socketCtx = globalProps?.socketCtx;
        if (socketCtx && userInfo?.id) {
            // 先取消订阅
            socketCtx?.socketCloseSubscribe?.(getInBoxEnums(userInfo), {
                uniqueKey: 'message',
            });
            // 订阅webscoket
            const subList = getInBoxEnums(userInfo);
            socketCtx?.socketSubscribe?.({
                uniqueKey: 'message',
                receiveMessage: ({ subUrl }) => {
                    if (subUrl && subList.includes(subUrl)) {
                        getTabList();
                    }
                },
            }, subList);
        }
        return () => {
            // 取消订阅
            if (userInfo?.id) {
                socketCtx?.socketCloseSubscribe?.(getInBoxEnums(userInfo), {
                    uniqueKey: 'message',
                });
            }
        };
    }, [globalProps?.userInfoFromSession, globalProps?.socketCtx]);
    return (_jsxs(Card, { bodyStyle: { paddingTop: 12 }, children: [_jsxs(Spin, { spinning: dataLoading, children: [_jsx(Tabs, { onChange: onTabChange, activeKey: selectedTabKey + '', children: tabList.map((item, index) => (_jsx(Tabs.TabPane, { tab: _jsxs(_Fragment, { children: [_jsx("span", { children: item.msgTypeName }), item.number > 0 ? (_jsxs("span", { children: ["(", item.number > 99 ? '99+' : item.number, ")"] })) : ('')] }) }, index))) }), _jsxs("div", { className: "messageSearchBox", children: [_jsxs("div", { className: "flex1", children: [_jsx(Input.Search, { allowClear: true, style: { width: '30%', marginRight: '24px' }, placeholder: "\u8BF7\u8F93\u5165", value: inputKeyword, onChange: (e) => {
                                            setInputKeyword(e.target?.value || '');
                                        }, onSearch: (value) => {
                                            setKeyword(value?.trim());
                                            setPage({
                                                ...page,
                                                pageNum: 1,
                                            });
                                        } }), _jsxs(Radio.Group, { onChange: (e) => {
                                            setIsRead(e.target.value);
                                            setPage({
                                                ...page,
                                                pageNum: 1,
                                            });
                                        }, defaultValue: isRead, children: [_jsx(Radio.Button, { value: "", children: "\u5168\u90E8" }), _jsx(Radio.Button, { value: 1, children: "\u5DF2\u8BFB" }), _jsx(Radio.Button, { value: 0, children: "\u672A\u8BFB" })] })] }), _jsx(Button, { type: "primary", disabled: tabList?.length === 0 || tabList[selectedTabKey]?.number <= 0, onClick: () => setAllMsgReaded(), children: "\u5168\u90E8\u7F6E\u4E3A\u5DF2\u8BFB" })] }), _jsxs("div", { className: "messageContent", children: [dataList.data.map((item, index) => (_jsx("div", { className: "messageContentItemBox", children: _jsxs("div", { className: "messageContentItem", id: `message_item_${index}`, onClick: () => onMsgClick(item, index), children: [_jsx("div", { className: "messageIcon", children: _jsx("img", { src: `/public/message/${MESSAGE_IMG_MAP[item.msgTypeId] || 'default.png'}`, alt: "", width: 31, height: 31 }) }), _jsxs("div", { className: "messageFlex1", children: [_jsxs("div", { className: "messageFlex", children: [_jsxs("div", { className: "messageTitle", style: 
                                                            // 可以跳转
                                                            item.msgTypeName === '邀请成员通知' ||
                                                                item.webUrl ||
                                                                item.appType === 'SYSTEM_BUS_CODE'
                                                                ? {
                                                                    color: 'var( --lj-primary-color )',
                                                                }
                                                                : undefined, children: [_jsxs("span", { children: [selectedTabKey === 0 && (_jsxs("span", { children: ["\u3010", item.msgTypeName, "\u3011"] })), _jsx("span", { children: item.title })] }), !item.isRead && _jsx("div", { className: "unreadCircleIcon" })] }), _jsx("span", { className: "messageTime", children: momentDate(item.createdDatetime) })] }), _jsxs("div", { className: "messageContentText", children: [_jsx("div", { className: classnames('flex1', 'messageContentTextHtml', {
                                                                messageEllipsis1: item.isColleps === 1,
                                                                hiddenHeightSet: item.isColleps === 1 && item.isEditorContent === 1,
                                                                heightSet: item.isColleps === 2 && item.isEditorContent === 1,
                                                            }), dangerouslySetInnerHTML: { __html: item.content } }), item.isColleps === 1 && (_jsxs("div", { className: "moreBtn", onClick: (e) => onMsgReadAll(e, index), children: ["\u8BE6\u60C5", _jsx(RightOutlined, {})] })), item.isColleps === 2 && (_jsxs("div", { className: "moreBtn", onClick: (e) => onMsgReadAll(e, index, true), children: ["\u6536\u8D77", _jsx(LeftOutlined, {})] }))] })] })] }) }, item.id))), !dataLoading && !dataList.data?.length && (_jsx("div", { className: "emptyText", children: _jsx(Empty, {}) })), dataList?.data?.length > 0 && (_jsx("div", { className: "messagePagination", children: _jsx(Pagination, { showTotal: (total, range) => {
                                        return `共 ${total} 条记录`;
                                    }, ...freeTablePagination, pageSizeOptions: ['10', '20', '50', '100'], total: dataList.total, showQuickJumper: true, showSizeChanger: true, pageSize: page.pageSize, current: page.pageNum, onChange: (current, pageSize) => {
                                        setPage({
                                            pageNum: page.pageSize === pageSize ? current || 1 : 1,
                                            pageSize: pageSize,
                                        });
                                    } }) }))] })] }), _jsx(ReceiverDraw, { id: drawVisibleObj.id, visible: drawVisibleObj.receiverDraw, onVisibleChange: () => {
                    setDrawVisibleObj({
                        ...drawVisibleObj,
                        receiverDraw: false,
                    });
                } }), _jsx(SenderDraw, { id: drawVisibleObj.rowInfo?.id, visible: drawVisibleObj.senderDraw, onVisibleChange: () => {
                    setDrawVisibleObj({
                        ...drawVisibleObj,
                        senderDraw: false,
                    });
                } }), _jsx(FinanceAdminDraw, { nameList: drawVisibleObj.nameList, id: drawVisibleObj.rowInfo?.id, rowInfo: drawVisibleObj.rowInfo, visible: drawVisibleObj.financeAdminDraw, onVisibleChange: () => {
                    setDrawVisibleObj({
                        ...drawVisibleObj,
                        financeAdminDraw: false,
                    });
                } }), _jsx(CertifySenderDraw, { id: drawVisibleObj.id, visible: drawVisibleObj.certifySenderDraw, onVisibleChange: () => {
                    setDrawVisibleObj({
                        ...drawVisibleObj,
                        certifySenderDraw: false,
                    });
                } }), _jsx(MessageDetail, { open: open, onCancel: () => { setOpen(false); } })] }));
};
export default MessageIndex;
